import { useEffect, useState } from "react";
import publicApi from "@/lib/publicApi";
import { Bike, Loader2, CheckCircle2, XCircle, MailX } from "lucide-react";

export default function Unsubscribe() {
  const token = new URLSearchParams(window.location.search).get("u");
  const [state, setState] = useState("loading"); // loading | form | done | error | already
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) { setState("error"); return; }
    publicApi.get(`/public/unsubscribe/${token}`)
      .then((r) => { setInfo(r.data); setState(r.data.consenso_marketing ? "form" : "already"); })
      .catch(() => setState("error"));
  }, [token]);

  const confirm = async () => {
    setBusy(true);
    try { await publicApi.post(`/public/unsubscribe/${token}`); setState("done"); }
    catch (e) { setState("error"); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#FAF6F1] flex items-center justify-center px-4" style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}>
      <div className="bg-white rounded-2xl shadow-sm border border-stone-200 p-10 max-w-md w-full text-center" data-testid="unsub-page">
        <div className="inline-flex items-center gap-2 text-[#f98125] font-bold text-xl mb-6"><Bike className="h-6 w-6" /> Bicimone</div>
        {state === "loading" && <Loader2 className="h-8 w-8 animate-spin text-[#f98125] mx-auto" />}
        {state === "error" && (<><XCircle className="h-12 w-12 text-red-500 mx-auto mb-3" /><h2 className="font-display text-2xl">Link non valido</h2><p className="text-stone-600 mt-2">Il link di disiscrizione non è valido o è scaduto.</p></>)}
        {state === "already" && (<><CheckCircle2 className="h-12 w-12 text-emerald-500 mx-auto mb-3" /><h2 className="font-display text-2xl">Sei già disiscritto</h2><p className="text-stone-600 mt-2">L'indirizzo {info?.email} non riceve comunicazioni marketing.</p></>)}
        {state === "form" && (
          <>
            <MailX className="h-12 w-12 text-[#f98125] mx-auto mb-3" />
            <h2 className="font-display text-2xl">Disiscriviti</h2>
            <p className="text-stone-600 mt-2">Confermi di non voler più ricevere email promozionali all'indirizzo <b>{info?.email}</b>?</p>
            <button onClick={confirm} disabled={busy} data-testid="unsub-confirm" className="mt-6 w-full flex items-center justify-center gap-2 rounded-xl bg-[#f98125] text-white font-bold uppercase tracking-wide px-6 py-3 hover:bg-[#d96a12] disabled:opacity-60">
              {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : null} Conferma disiscrizione
            </button>
          </>
        )}
        {state === "done" && (<><CheckCircle2 className="h-12 w-12 text-emerald-500 mx-auto mb-3" data-testid="unsub-done" /><h2 className="font-display text-2xl">Disiscrizione completata</h2><p className="text-stone-600 mt-2">Non riceverai più email promozionali. Ci dispiace vederti andare!</p></>)}
      </div>
    </div>
  );
}
